import React, { useState } from "react";
import {
  Box,
  Button,
  Container,
  Divider,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import priceImage from "../../assets/icons/Star.png";
import { setStep } from "../../redux/reducers/stepSlice";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

import { unwrapResult } from "@reduxjs/toolkit";
import { updateLabourAndPacking } from "../../redux/action/labour-and-packing";

interface ChooseServiceProps {
  onNext: () => void;
  onBack: () => void;
}

const PriceOfPackingAndLoading: React.FC<ChooseServiceProps> = ({
  onNext,
  onBack,
}) => {
  const [price, setPrice] = useState(500);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const dispatch = useDispatch();
  const { canonicalId } = useParams();
  const handleContinue = () => {
    const sendData = {
      canonical_id: canonicalId,
      price,
    };
    if (canonicalId) {
      dispatch<any>(updateLabourAndPacking(sendData))
        .then(unwrapResult)
        .then((res: any) => {})
        .catch((err: any) => {
          console.error("Failed to fetch move data:", err);
        });
    }
    dispatch(setStep(6));
  };

  return (
    <div>
      <Container
        sx={{
          width: "100%",
          maxWidth: "100%",
          height: isMobile ? "93vh" : "80vh",
          boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
          padding: isMobile ? "20px" : "20px",
          background: "#f2f0f0",
          margin: "0 auto",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ flexGrow: 1 }}>
          <Typography
            fontWeight={700}
            fontSize={isMobile ? "16px" : "18px"}
            textAlign="center"
            mb={2}
          >
            Price of Packing and Loading
          </Typography>
          <Divider sx={{ background: "#D3D3D3" }} />

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "20px",
            }}
          >
            <img src={priceImage} alt="Price" style={{ height: "120px" }} />
          </Box>

          <Typography
            fontWeight={600}
            fontSize={24}
            color={"#fff"}
            sx={{
              position: "relative",
              top: "-78px",
              left: "0px",
              textAlign: "center",
            }}
          >
            {price} $
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            justifyContent: "space-between",
            paddingBottom: "20px",
            marginTop: "auto",
          }}
        >
          <Button
            variant="outlined"
            sx={{
              borderRadius: "20px",
              borderColor: theme.palette.primary.main,
              color: theme.palette.primary.main,
              padding: isMobile ? "8px 20px" : "8px 45px",
              textTransform: "none",
              fontSize: isMobile ? "12px" : "14px",
              fontWeight: "600",
            }}
            onClick={onBack}
          >
            Back
          </Button>
          <Button
            variant="contained"
            sx={{
              borderRadius: "20px",
              backgroundColor: theme.palette.primary.main,
              color: "#fff",
              padding: isMobile ? "8px 20px" : "8px 45px",
              textTransform: "none",
              fontSize: isMobile ? "12px" : "14px",
              fontWeight: "600",
              "&:hover": { backgroundColor: "#357ABD" },
            }}
            onClick={handleContinue}
          >
            Continue
          </Button>
        </Box>
      </Container>
    </div>
  );
};

export default PriceOfPackingAndLoading;
